var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirstMedal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m155.028 355.114-20.298.99-39.354 113.066c-1.254 3.601 1.664 7.284 5.457 6.886l55.163-5.776c1.541-.161 3.073.372 4.181 1.455l39.655 38.779c2.726 2.666 7.3 1.591 8.553-2.01l39.611-113.805-11.68-11.336z",
    fill: "#ff4755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m247.996 394.699 8.004-22.995-113.29-38.526-7.98 22.927c32.17 22.955 71.122 37.007 113.266 38.594z",
    fill: "#fc2b3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.972 355.114 20.298.99 39.354 113.066c1.254 3.601-1.664 7.284-5.457 6.886l-55.163-5.776c-1.541-.161-3.073.372-4.18 1.455l-39.655 38.779c-2.726 2.666-7.3 1.591-8.553-2.01l-39.611-113.805 11.68-11.336z",
    fill: "#ff4755"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.004 394.699-8.004-22.995 113.29-38.526 7.98 22.927c-32.17 22.955-71.122 37.007-113.266 38.594z",
    fill: "#fc2b3a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 360.116c-185.852 0-185.774-180.529-185.62-183.632 4.879-98.29 86.118-176.484 185.62-176.484s180.741 78.194 185.62 176.485c.154 3.103.232 183.631-185.62 183.631z",
    fill: "#ffe27a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 352.969c-99.502 0-180.738-78.194-185.618-176.485-.154 3.103-.234 6.226-.234 9.367 0 102.643 83.209 185.852 185.852 185.852s185.852-83.209 185.852-185.852c0-3.142-.08-6.264-.234-9.367-4.88 98.291-86.116 176.485-185.618 176.485z",
    fill: "#f9cf58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 320.126c-146.117 0-146.313-143.682-146.117-146.78 4.831-76.496 68.403-137.044 146.117-137.044s141.286 60.548 146.117 137.044c.196 3.097 0 146.78-146.117 146.78z",
    fill: "#ffba57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m256 313.529c-77.713 0-141.274-60.55-146.105-137.045-.196 3.098-.307 6.22-.307 9.367 0 80.861 65.551 146.412 146.412 146.412s146.412-65.551 146.412-146.412c0-3.148-.111-6.269-.307-9.367-4.831 76.495-68.392 137.045-146.105 137.045z",
    fill: "#ffac3e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.35 272.82c-10.165 0-18.406-8.24-18.406-18.406v-9.735-93.416s-11.013 11.045-24.19 4.418c-10.274-5.167-10.274-18.466-10.274-18.466l22.693-38.306c3.314-5.594 9.334-9.025 15.836-9.025h14.341c10.165 0 18.406 8.24 18.406 18.406v136.389 9.735c0 10.166-8.241 18.406-18.406 18.406z",
    fill: "#ffe27a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#f9cf58"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m243.415 136.8c-4.885 8.247-15.272 11.823-23.935 7.718-3.506-1.661-6.209-4.242-8.006-7.29-5.111 8.646-2.344 19.769 6.166 25.024 8.776 5.42 20.503 2.184 25.759-6.691l2.546-4.299v-13.771c0-1.382-1.825-1.881-2.53-.691z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m264.35 263.085c-10.165 0-18.406-8.24-18.406-18.406v18.735c0 10.166 8.241 18.406 18.406 18.406s18.406-8.24 18.406-18.406v-18.735c0 10.166-8.241 18.406-18.406 18.406z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstMedal);
export default __webpack_public_path__ + "static/media/FirstMedal.5b79fcaf.svg";
export { ForwardRef as ReactComponent };